import React, { FC } from 'react';
import { SCUIButton, SCUIDateRanger } from '../../atomic/atoms';
import { Box, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';

interface IProps {
    formData?: any;
    onCloseMenu?: any;
    setFormData?: any;
    fiscalType?: any;
    fiscalSearch?: any;
    setPageNumber?: any;
    pageSize?: any;
}
export const FiscalDrawer: FC<IProps> = ({
    formData,
    onCloseMenu,
    setFormData,
    fiscalType,
    fiscalSearch,
    setPageNumber,
    pageSize,
}) => {
    const { t } = useTranslation();
    const handleChange = (event: any) => {
        setFormData((prev: any) => ({
            ...prev,
            fiscalType: Number(event.target.value),
        }));
    };
    const _handleChangeDate = (event: [string | null, string | null]) => {
        setFormData((prev: any) => ({
            ...prev,
            startDate: event[0],
            endDate: event[1],
        }));
    };
    const clearForm = () => {
        setFormData({
            orderNumber: '',
            fiscalType: null,
            startDate: null,
            endDate: null,
            email: '',
            uuid: '',
            referenceUuid: '',
        });
    };
    const handleChangeFormData = (field: keyof typeof formData, value: any) => {
        setFormData((prev: any) => ({
            ...prev,
            [field]: value,
        }));
    };
    return (
        <Grid container padding={4} spacing={3}>
            <Grid
                container
                sx={{ marginBottom: '2rem' }}
                size={{
                    xl: 12,
                    lg: 12,
                    md: 12,
                    xs: 12,
                }}
            >
                <Grid
                    size={{
                        xl: 11,
                        lg: 11,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <h2>{t('general.detailedSearch')}</h2>
                </Grid>

                <Grid
                    sx={{ display: 'flex' }}
                    size={{
                        md: 1,
                        xs: 1,
                        lg: 1,
                    }}
                >
                    <CloseIcon className="svg_icons" onClick={onCloseMenu} />
                </Grid>
            </Grid>
            <Grid
                container
                spacing={2}
                sx={{
                    '& > .MuiGrid-item': {
                        pb: '1rem',
                    },
                }}
            >
                <Grid
                    size={{
                        xl: 11,
                        lg: 11,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <FormControl style={{ width: '100%' }} required>
                        <SCUIDateRanger
                            fromDate={formData?.startDate}
                            toDate={formData?.endDate}
                            setDateRange={_handleChangeDate}
                            dateFormat="YYYY-MM-DD"
                        />
                    </FormControl>
                </Grid>
                <Grid
                    size={{
                        xl: 1,
                        lg: 1,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <Tooltip title={t('emailTemplateBuilder.keywordIsRequired')}>
                        <h3>(*)</h3>
                    </Tooltip>
                </Grid>
                <Grid
                    size={{
                        xl: 11,
                        lg: 11,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <FormControl fullWidth required>
                        <InputLabel id="fiscal-type-label">{t('fiscal.fiscalType')}</InputLabel>
                        <Select
                            labelId="fiscal-type-label"
                            id="fiscal-type-select"
                            value={formData?.fiscalType}
                            onChange={handleChange}
                            required
                        >
                            {fiscalType?.map((type: any) => (
                                <MenuItem key={type.fiscalType} value={type.fiscalType}>
                                    {type.description}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid
                    size={{
                        xl: 1,
                        lg: 1,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <Tooltip title={t('emailTemplateBuilder.keywordIsRequired')}>
                        <h3>(*)</h3>
                    </Tooltip>
                </Grid>
                <Grid
                    size={{
                        xl: 11,
                        lg: 11,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <TextField
                        id="outlined-required"
                        label={t('general.orderNo')}
                        value={formData?.orderNumber}
                        onChange={(e) => handleChangeFormData('orderNumber', e.target.value)}
                        type="number"
                        fullWidth
                    />
                </Grid>

                <Grid
                    size={{
                        xl: 11,
                        lg: 11,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <TextField
                        id="outlined-required"
                        label={t('general.eMail')}
                        value={formData?.email}
                        onChange={(e) => handleChangeFormData('email', e.target.value)}
                        fullWidth
                    />
                </Grid>

                <Grid
                    size={{
                        xl: 11,
                        lg: 11,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <TextField
                        id="outlined-required"
                        label="UUID"
                        value={formData?.uuid}
                        onChange={(e) => handleChangeFormData('uuid', e.target.value)}
                        fullWidth
                    />
                </Grid>

                <Grid
                    size={{
                        xl: 11,
                        lg: 11,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <TextField
                        id="outlined-required"
                        label={t('fiscal.referenceUUID')}
                        value={formData?.referenceUuid}
                        onChange={(e) => handleChangeFormData('referenceUuid', e.target.value)}
                        fullWidth
                    />
                </Grid>
                <Grid
                    size={{
                        xl: 11,
                        lg: 11,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <Box display="flex" justifyContent="space-between" alignItems="center" gap="16px">
                        <SCUIButton
                            text={t('general.clear')}
                            onClick={clearForm}
                            buttonType="button"
                            type="primary"
                            sizeType="fixed"
                            size={'l'}
                            style={{ backgroundColor: 'red', borderColor: 'red' }}
                            fullwidth
                        />
                        <SCUIButton
                            text={t('general.filter')}
                            type="primary"
                            sizeType="fixed"
                            size={'l'}
                            onClick={() => {
                                setPageNumber(0);
                                fiscalSearch(0, pageSize);
                                onCloseMenu();
                            }}
                            fullwidth
                        />
                    </Box>
                </Grid>
            </Grid>
        </Grid>
    );
};
